<template>
  <div id="codificator-builder-new-or-edit" class="wrapper-content w-100">
    <p>Componente en estado de prueba</p>
    <Component
      v-if="component"
      :is="component.label"
      @input="$emit('input', $event)"
    />
    <!-- <pre>
      {{components}}
    </pre> -->
  </div>
</template>

<script>
import customComponentsList from '@/components/form/customElementsLoader.js'

export default {
  data () {
    return {
      id: 'firmantes'
    }
  },
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    components () {
      return customComponentsList
    },
    component () {
      return this.label ? this.getComponents(this.label.toLowerCase()) : null
    }
  },
  methods: {
    getComponents (id) {
      let componentLoaded = null
      this.components.forEach(comp => {
        if (comp.id === id) componentLoaded = comp
      })
      return componentLoaded
    }
  }
}
</script>

<style>

</style>
